(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["activity-image"] && !Shopify.designMode) return;
  try {
    class ActivityImage {
    constructor() {
        if ($('.activity-block--pic a[data-btn-to-login="true"]').length > 0) {
            this.bindClickEvent();
        }
    }
    bindClickEvent() {
        $('.activity-block--pic a[data-btn-to-login="true"]').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (pageInfo.customerInfo?.id) {
                pushSuccessMessage($(this).data('loggedInMsg') || 'You are already logged in.');
            } else {
                const hash = $(this).parent().parent().parent().attr('anchor');
                window.jackeryLoginApp && window.jackeryLoginApp.modalLogin({
                    return_url: window.location.href + "?hash=" + hash,
                    "register_act": "Account-Register"
                });
            }
        });
    }
}
$(function() {
    new ActivityImage();
})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["activity-pic-swiper"] && !Shopify.designMode) return;
  try {
    $(function (){
        const activityPicSwiper = $('.activity-pic-swiper');
        if (activityPicSwiper.length === 0) return

        activityPicSwiper.each(function (){
            const index = $(this).data('index');
            const currentComponent = `.activity-pic-swiper-${index}`;
            const currentSwiper =  $(`${currentComponent} .activity-pic-container`)
            const clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
            new Swiper(currentSwiper[0], {
                spaceBetween: clientWidth > 1024 ? 20 : 24,
                slidesPerView: 'auto',
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                observer: true, // 开启动态检查器，监测swiper和slide
                observeParents: true, // 监测Swiper 的祖/父元素
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 1
                },
                allowTouchMove: true,
                centeredSlides: false,
                loop: false,
                navigation: {
                    prevEl: `.activity-pic-swiper-${index} .swiper-activity-button-prev`,
                    nextEl: `.activity-pic-swiper-${index} .swiper-activity-button-next`
                },
                pagination: {
                    el: `${currentComponent} .activity-pagination`,
                    clickable: true,
                    bulletClass: 'slideshow-pagination-item',
                    bulletActiveClass: 'active pagination-active',
                    clickableClass: 'slideshow-pagination-clickable',
                    modifierClass: 'slideshow-pagination-',
                    renderBullet: function (index) {
                        let paginationItem = `<span class="slideshow-pagination-item" 
                            data-ga-event="activity_page_user_clicks"
                            data-ga-action="click"
                            data-ga-params-current_page=""
                            data-ga-params-module="Picture Display"
                            data-ga-params-position="Points"
                            data-tab-item >`;
                        paginationItem = (index <= 10) ? paginationItem +
                            '<span class="pagination-separator"><span class="pagination-separator-loader"></span></span>' :
                            paginationItem;
                        paginationItem += '</span>';
                        return paginationItem;
                    },
                },
                on:{
                    slideChange:function(){
                        const activeIndex = this.realIndex;
                        document.querySelectorAll(`.activity-pic-swiper-${index} .slideshow-pagination-item`).forEach((el, i) => {
                            el.classList.toggle('active', i === activeIndex);
                        });
                    },
                    touchMove:function(){
                        const activeIndex = this.realIndex;
                        document.querySelectorAll(`.activity-pic-swiper-${index} .slideshow-pagination-item`).forEach((el, i) => {
                            el.classList.toggle('active', i === activeIndex);
                        });
                    },
                    transitionEnd: function() {
                        updatePaginationHighlight(this);
                    },
                }

            })
            function updatePaginationHighlight(swiper) {
                const activeIndex = swiper.isEnd ? swiper.pagination.bullets.length - 1 : swiper.realIndex;
                document.querySelectorAll(`.activity-pic-swiper-${index} .slideshow-pagination-item`).forEach((el, i) => {
                    el.classList.toggle('active', i === activeIndex);
                });
            }
            // 埋码
            $(`${currentComponent} .swiper-button-prev`).attr("data-ga-params-current_page", window.location.href);
            $(`${currentComponent} .swiper-button-next`).attr("data-ga-params-current_page", window.location.href);
            $(`${currentComponent} .swiper-slide`).attr("data-ga-params-current_page", window.location.href);


            $(`${currentComponent} .swiper-slide`).each(function() {
                const pcImage = $(this).data('pcimage');
                const mbImage = $(this).data('mbimage');
                if (clientWidth>1024){
                    $(this).data('ga-params-url', pcImage);
                    $(this).attr('data-ga-params-url', pcImage);
                }else{
                    $(this).data('ga-params-url', mbImage);
                    $(this).attr('data-ga-params-url', mbImage);
                }

                if(!$(this).attr("href") && $(this).attr("data-code")) {
                    const code = $(this).attr("data-code")
                    try {
                        $(this).off('click').click(function() {
                            const cb = eval( code );
                            if(cb && typeof cb === "function") {
                                cb();
                            }
                        })
                    } catch(e) {
                        console.error(e)
                    }
                }
            });

            $(`${currentComponent} .slideshow-pagination-item`).attr("data-ga-params-current_page", window.location.href);
        })
    })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["backtop"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
        const distance = 600

        $(window).scroll(function () {
            if ($(this).scrollTop() > distance) {
                $('#back-top').fadeIn();
                $('#back-top').css('opacity', 1)
            } else {
                $('#back-top').fadeOut();
            }
        });

        // 滚动到顶部
        window.Jackery.goBackTopStatus = false; // 全局返回顶部状态位
        if (document.querySelector('#back-top')) {
            document.querySelector('#back-top').onclick = () => {
                window.Jackery.goBackTopStatus = true;
                $('html,body').animate({
                    scrollTop: 0
                }, 500, function () {
                    window.Jackery.goBackTopStatus = false;
                });
                return false
            }
        }
    })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ga-manger"] && !Shopify.designMode) return;
  try {
    window.addEventListener('DOMContentLoaded', (event) => {
      setTimeout(() => {
        (function () {
            const gaElts = document.querySelectorAll("[data-ga-event]");
            if (gaElts.length === 0) return;
            [...gaElts].map((elt) => {
                try {
                    const evtType = elt.getAttribute("data-ga-action")
                    if (!evtType) return
                    const evtName = elt.getAttribute("data-ga-event")
                    if (!evtName) return

                    if(elt.getAttribute("ga-loaded")) return
                    !elt.getAttribute("ga-loaded") && elt.addEventListener(evtType, function (evt) {
                        if(!evt.isTrusted) return
                        const target = $(this)[0]
                        let url = '';
                        if (target.getAttribute("data-href")) {
                            // evt.preventDefault();
                            url = target.getAttribute("data-href");
                        }
                        let params = {}
                        const attributeNames = target.getAttributeNames();

                        attributeNames.forEach(attribute => {
                            if(attribute.indexOf("data-ga-params-") === 0) {
                                const key = attribute.replace("data-ga-params-", "")
                                params[key] = target.getAttribute(attribute) === 'null' ? null : target.getAttribute(attribute)
                            }
                        });

                        window.dataLayer.push({ event_parameters: null });
                        window.dataLayer.push({
                            event: "ga4Event",
                            event_name: evtName,
                            event_parameters: {
                                current_page: window.location.href,
                                ...params
                            }
                        });

                        elt.setAttribute("ga-loaded", true)

                        setTimeout(function() {
                            if (url) {
                                if(target.getAttribute("target") === "_blank") {
                                    window.open(url, "_blank");
                                } else {
                                    window.location.href = url
                                }
                            }
                        }, 40)
                    });
                } catch (e) {
                    console.log(
                        "Something wrong happened when setting up event handling for ga4Events."
                    );
                }
            });
        })();
      }, 20)
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-after-sales"] && !Shopify.designMode) return;
  try {
    class AfterSales {
        constructor(e) {
            this.DOM = e.el;
            if (!document.querySelector(this.DOM)) return
            this.swiper = null;
            this.init()
        }

        init() {
            this.checkViewport();
            let this_ = this
            window.addEventListener('resize', function () {
                this_.checkViewport();
            });

            window.addEventListener('scroll', function () {
                const target = document.querySelector(".header-after-sales")
                if(!target) return
                const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                if(scrollTop > 500) {
                    target.classList.add("show");
                    if(document.querySelector("jky-header")) {
                        const _h = document.querySelector("jky-header").getBoundingClientRect().height
                        let _h_num = _h + 34;
                        document.querySelector("body").style.setProperty(
                        '--jky-header-h',
                        `${Math.floor(_h_num)}px`
                        );
                    }
                    if(document.querySelector(".after-sales-container").getAttribute("data-load") !== "loaded") {
                        this_.loadImg()
                    }
                } else {
                    target.classList.remove("show");
                    if(document.querySelector("jky-header") && document.querySelector("body").style.getPropertyValue('--jky-header-h')) {
                        const _h = Math.floor(document.querySelector("jky-header").getBoundingClientRect().height)
                        const _jky_h = Number(document.querySelector("body").style.getPropertyValue('--jky-header-h').replace('px', ''))
                        if(_jky_h > _h + 5) {
                            let _h_num = _jky_h - 34;
                            _h_num > 0 && document.querySelector("body").style.setProperty(
                            '--jky-header-h',
                            `${Math.floor(_h_num)}px`
                            );
                        }
                    }
                }
            });

            $(".header-after-sales .after-sales-item").click(function(e) {
                ZModle.getInstance(`<div class="after-sales-item__content jky-text-base">${$(this).attr('data-content')}</div>`, {
                    id: `after-sales-item__${$(this).attr('data-index')}`,
                    header: $(this).text() || '',
                    class: "after-sales__private_modal"
                })
            })
        }

        initSwiper() {
            this.swiper = new Swiper(this.DOM, {
                autoplay: {
                    delay: 4000
                },
                loop: true
            });
        }

        destroySwiper() {
            if (this.swiper) {
                this.swiper.destroy();
                this.swiper = null;
            }
        }

        checkViewport() {
            if (window.innerWidth < 1024) {
                if (!this.swiper) {
                    this.initSwiper();
                }
            } else {
                if (this.swiper) {
                    this.destroySwiper();
                }
            }
        }

        loadImg() {
            const $el = document.querySelectorAll(".after-sales-container img.lazyimg")
            $el.forEach(item => {
                const src = item.getAttribute("data-src")
                if(src && !item.classList.contains("loaded")) {
                    item.setAttribute("src", src)
                    item.classList.add("loaded")
                }
            })
            document.querySelector(".after-sales-container").setAttribute("data-load", "loaded")
        }
    }

    $(document).ready(function() {
        new AfterSales({
            el: '.after-sales-container'
        })
    })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["subscribe-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get("jky-subscrible-v1")) {
        class JkySubscribleV1 extends HTMLElement {
            constructor() {
                super()
                this.pageUrl = this.querySelector('.subscrible-page-url') || null
                this.initEvent()
            }
            initEvent() {
                this.pageUrl.value = window.location.href;
                window.toSubscribleSubmit = (e) => {
                    this.toSubscribleSubmit(e)
                }
            }
            toSubscribleSubmit(e) {
                if (e.response && e.response.code === 200) {
                   const msg =  $('.jky-subscrible-v1 .form-row_submit button').data('success') || e.response.message;
                   pushSuccessMessage(msg);
                    //埋码
                    const title = document.querySelector('h1').textContent.trim() || '';
                    const position = this.querySelector('.subscrible-title').textContent.trim() || '';
                    const button_name = this.querySelector('.submit-btn').textContent.trim() || '';
                    gaPushDataLayer('blog_detail_page_user_clicks', {  module: "Subscribe Submit", title, position, button_name });
                }
            }
        }
        customElements.define('jky-subscrible-v1', JkySubscribleV1);
    }
  } catch(e) { console.error(e); }
})();

})();
